@import '../../../../constants/spacing.module.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../settings-page.module.less';

.package-sets-table {
  width: 100%;
  border: @settings-page--table--border;
  color: @settings-page--table--body--cell--text-color;
  background-color: @settings-page--table--body--cell--background-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
}

.header-row {
  font-weight: @settings-page--table--header--cell--font-weight;
  color: @settings-page--table--header--cell--text-color;
  background-color: @settings-page--table--header--cell--background-color;
  border-bottom: @settings-page--table--border;
}

.actions-cell {
  display: flex;
  justify-content: flex-end;

  .icon {
    width: 18px;
    height: 18px;
  }
}

.package-row {
  border-bottom: none;
}

.package-set-row {
  border-bottom: @settings-page--table--border;
}

.last-package-set-row {
  border-bottom: none;
}

.package-sets-description {
  margin: @space-0 @space-0 @space-24;
}

.add-package-set-button-row {
  justify-content: flex-end;
}

.add-package-set-button-content {
  align-items: center;

  .icon {
    width: 12px;
    height: 12px;
    margin-right: @space-8;
  }
}

.image-wrapper {
  align-items: center;
  padding: @space-24;
  gap: @space-8;
}

.menu-toggler {
  height: 32px;
  width: 32px;
  border-radius: 6px;
  color: var(--grey-900);

  &:hover {
    background-color: @table--actions-dropdown--hover--background-color;
    color: @table--actions-dropdown--hover--text-color;
  }
}

.menu-toggler-contents {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}
